module.exports = __webpack_public_path__ + "img/ic_hub_connected.59ee3c40.svg";